import { createUseCase } from '@brickflow/http'

import type { AnnouncementType } from '@/core/constants/announcement'

import { createGet } from '@/core/util'

export default createUseCase()(({ httpClient }) => ({
  addClick(payload: { event: string; id?: number; type?: AnnouncementType; uniq: number }) {
    httpClient.post('user/lazynotification/analytic/add_click', payload, {
      ignore: () => {
        return true
      },
    })
  },

  get: createGet()('user/lazynotification'),

  markRead(payload: { id: null | number; type: AnnouncementType }) {
    httpClient.post('user/lazynotification/mark_as_read', payload)
  },

  news: createGet()('user/lazynotification/news'),
}))
